<template>
  <div class="paging-container clearfix">
    <!-- <div class="cont-box"><span>共计{{totalNumber}}条</span></div>
    <div class="cont-box"><span>总计{{totalPages}}页</span></div> -->
    <div class="select-box cont-box">
      <!-- 之前用的 -->
      <el-pagination @size-change="handleSizeChange" @current-change="clickPage" layout=" sizes, prev, pager, next, jumper" :page-size="pageShowTotal" :page-sizes="[10, 20, 50, 100]" :current-page="showActivePageIndex" :total="totalNumber" v-if="isShowIndex == '1'">
      </el-pagination>

      <el-pagination v-if="isShowIndex == ''" @current-change="clickPage" layout="prev, next" :prev-text="'上一页'" :next-text="'下一页'" :current-page="showActivePageIndex">
      </el-pagination>

      <!-- <el-pagination @size-change="handleSizeChange" @current-change="clickPage" :current-page="showActivePageIndex" :page-sizes="[10, 20, 30, 40]" :page-size="100" layout="total, sizes, prev, pager, next, jumper" :total="totalNumber">
      </el-pagination> -->

      <!-- <el-pagination @current-change="clickPage" layout="prev, pager, next" :page-size="pageShowTotal" :page-sizes="[10, 20, 30, 40]" :current-page="showActivePageIndex" :total="totalNumber">
      </el-pagination> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Paging',
  props: {
    totalNumber: {
      type: Number,
      default: 1
    }, // 总条数
    pageShowTotal: {
      type: Number,
      default: 10
    }, // 每页展示多少条数据 默认一页展示10条
    showActivePageIndex: {
      type: Number,
      default: 1
    }, // 父组件传来的页码样式index
    isShowIndex: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      selectShowNumber: 10, // 默认一页展示10条,select框的value值
      thisPage: 1, // 当前选中页数
    }
  },
  mounted () {
  },
  computed: {
    totalPages () {
      return Math.ceil(this.totalNumber / this.selectShowNumber)
    }
  },
  watch: {
    totalNumber () {
      this.thisPage = 1
      this.selectShowNumber = this.pageShowTotal
    }
  },
  methods: {
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
      this.selectShowNumber = val;
      this.thisPage = 1
      this.$emit('callBack', this.thisPage, this.selectShowNumber)
    },
    clickPage (val) {
      this.thisPage = val;
      console.log(this.selectShowNumber)
      this.$emit('callBack', this.thisPage, this.selectShowNumber)
    },
  }
}
</script>

<style lang="less" scoped>
::v-deep {
  .el-pagination button:hover {
    color: #c51015;
  }
  .el-pagination button:disabled {
    color: #c0c4cc;
    background-color: #fff;
    cursor: not-allowed;
  }
  .el-pager li.active {
    color: #c51015;
    cursor: default;
  }
  .el-pagination .el-pager li:hover {
    color: #c51015;
  }
  .el-pagination .el-pager li:not(.disabled):hover {
    color: #c51015;
  }
}

.paging-container {
  font-size: 14px;
  font-family: PingFangSC-Regular;
  color: #777e8c;
  letter-spacing: 0;
  line-height: 30px;
  height: 30px;
  display: inline-block;
  margin-top: 30px;
}

.clearfix {
  zoom: 1;
}

.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: ' ';
  clear: both;
  height: 0;
  font-family: PingFangSC-Regular;
}

.cont-box {
  float: left;
  margin-right: 4px !important;
}
</style>
